//#region IMPORT
import React, { Fragment, useState } from 'react';
import { useSelector } from 'react-redux';
/** Components Import */
import {
  Box,
  Stack,
  Typography,
  Grid,
  Card,
  CardContent,
  Chip,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider,
  IconButton,
} from '@mui/material';
import { Button, Dialog } from '../../../../Components/MUIs';
import DocumentPreview from '../../../../Components/Ui/DocumentPreview';
import VideoPreview from '../../../../Components/Ui/VideoPreview';
/** Icons Import */
import {
  Description as DescriptionIcon,
  Movie as MovieIcon,
  Assignment as AssignmentIcon,
  CheckCircle as CheckCircleIcon,
  Visibility as VisibilityIcon,
} from '@mui/icons-material';
//#endregion

function M_TBS_CUSTOM(props) {
  const { statusBar, navBar } = useSelector((state) => state.systemBar);
  const [documentPreviewOpen, setDocumentPreviewOpen] = useState(false);
  const [documentPreviewData, setDocumentPreviewData] = useState(null);
  const [selectedItemForPreview, setSelectedItemForPreview] = useState(null);
  const [videoPreviewOpen, setVideoPreviewOpen] = useState(false);
  const [videoPreviewData, setVideoPreviewData] = useState(null);

  const listData = props.listData ?? [];

  const IsEducationSelected = (item) =>
    props.selectedEducations?.some(
      (selected) =>
        (selected.eduLocation || selected.eduFilePath) ===
        (item.eduLocation || item.eduFilePath)
    );

  const IsWorkplanSelected = (item) =>
    props.selectedWorkplans?.some(
      (selected) => selected.filePath === item.filePath
    );

  const GetEducationSelectionOrder = (item) => {
    const index = (props.selectedEducations ?? []).findIndex(
      (selected) =>
        (selected.eduLocation || selected.eduFilePath) ===
        (item.eduLocation || item.eduFilePath)
    );
    return index >= 0 ? index + 1 : null;
  };

  const GetWorkplanSelectionOrder = (item) => {
    const index = (props.selectedWorkplans ?? []).findIndex(
      (selected) => selected.filePath === item.filePath
    );
    return index >= 0 ? index + 1 : null;
  };

  const OpenDocumentPreview = (item, type) => {
    if (type === 'education') {
      const filePath = item.eduLocation || item.eduFilePath || '';
      setSelectedItemForPreview(item);
      setDocumentPreviewData({
        filePath: filePath,
        fileNm: item.eduFileName || '교육 파일',
      });
      props.setListDialogOpen?.(false);
      setDocumentPreviewOpen(true);
      return;
    }

    if (type === 'workplan') {
      const filePath = item.filePath || '';
      setSelectedItemForPreview(item);
      setDocumentPreviewData({
        filePath: filePath,
        fileNm: item.fileName || '작업계획서',
      });
      props.setListDialogOpen?.(false);
      setDocumentPreviewOpen(true);
    }
  };

  const HandleItemClick = (item) => {
    if (
      props.selectedType === 'education' ||
      props.selectedType === 'workplan'
    ) {
      props.HandleToggleMultiSelect(item);
      return;
    }

    const currentSelected = props.selectedVideo;
    const isSameItem =
      currentSelected && currentSelected.videoFileName === item.videoFileName;

    if (isSameItem) {
      props.HandleConfirmPreview(null);
      return;
    }

    if (props.selectedType === 'video') {
      setSelectedItemForPreview(item);
      setVideoPreviewData({
        videoLocation: item.videoLocation || item.videoFilePath || '',
        videoFileName: item.videoFileName || '교육 동영상',
      });
      props.setListDialogOpen?.(false);
      setVideoPreviewOpen(true);
    }
  };

  const HandleMenuClick = (type) => {
    if (props.HandleSelectType) {
      props.HandleSelectType(type);
    }
  };

  const menuItems = [
    {
      id: 'video',
      label: '교육 동영상',
      icon: MovieIcon,
      bgColor: '#E0EDFF',
      type: 'video',
    },
    {
      id: 'education',
      label: '교육 파일',
      icon: DescriptionIcon,
      bgColor: '#E8F7E4',
      type: 'education',
    },
    {
      id: 'workplan',
      label: '작업계획서',
      icon: AssignmentIcon,
      bgColor: '#FFE9E9',
      type: 'workplan',
    },
  ];

  return (
    <>
      <Stack sx={{ display: 'flex', alignItems: 'start', m: 2, mt: 0 }}>
        <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
          TBM 자료 선택
        </Typography>
        <Typography sx={{ color: '#828282', mb: 1 }}>
          교육 동영상, 교육 파일, 작업계획서를 선택해주세요.
        </Typography>
        <Typography sx={{ color: '#999', fontSize: '13px' }}>
          • 교육 동영상: 1개 선택
        </Typography>
        <Typography sx={{ color: '#999', fontSize: '13px' }}>
          • 교육 파일, 작업계획서: 최대 {props.maxMultiSelect}개까지 선택 가능
        </Typography>
        <Typography sx={{ color: '#999', fontSize: '13px' }}>
          • 교육 파일: 해당 부서에 등록된 모든 자료
        </Typography>
        <Typography sx={{ color: '#999', fontSize: '13px' }}>
          • 작업계획서: 최근 3년동안 등록된 자료
        </Typography>
      </Stack>
      <Box sx={{ px: 2, pb: 2 }}>
        <Grid container spacing={2}>
          {menuItems.map((item) => {
            const IconComponent = item.icon;
            const isSelected =
              (item.type === 'video' &&
                props.selectedVideo &&
                props.selectedVideo.videoFileName) ||
              (item.type === 'education' &&
                props.selectedEducations?.length > 0) ||
              (item.type === 'workplan' && props.selectedWorkplans?.length > 0);

            const selectedNames =
              item.type === 'video' && props.selectedVideo
                ? [props.selectedVideo.videoFileName || '선택됨']
                : item.type === 'education'
                  ? (props.selectedEducations || []).map(
                      (selected, index) =>
                        `${index + 1}. ${selected.eduFileName || '선택됨'}`
                    )
                  : item.type === 'workplan'
                    ? (props.selectedWorkplans || []).map(
                        (selected, index) =>
                          `${index + 1}. ${selected.fileName || '선택됨'}`
                      )
                    : [];

            return (
              <Grid item xs={12} key={item.id}>
                <Card
                  onClick={() => HandleMenuClick(item.type)}
                  sx={{
                    borderRadius: 3,
                    height: '100%',
                    p: 0,
                    m: 0,
                    backgroundColor: item.bgColor,
                    cursor: 'pointer',
                    border: isSelected ? '2px solid #1976d2' : 'none',
                    '&:hover': {
                      boxShadow: 3,
                    },
                  }}
                >
                  <CardContent
                    sx={{
                      '&:last-child': { pb: 1 },
                      p: 2,
                      m: 0,
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      gap: 2,
                    }}
                  >
                    <Box
                      sx={{
                        flex: 1,
                        minWidth: 0,
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                          mb: 1,
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          fontWeight="bold"
                          sx={{
                            fontSize: '18px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {item.label}
                        </Typography>
                        {isSelected && (
                          <CheckCircleIcon
                            sx={{
                              color: '#1976d2',
                              fontSize: '20px',
                              flexShrink: 0,
                            }}
                          />
                        )}
                      </Box>
                      {isSelected && (
                        <Box
                          sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 0.5,
                          }}
                        >
                          {selectedNames.map((name, chipIndex) => (
                            <Chip
                              key={`${item.id}-${chipIndex}`}
                              label={name}
                              size="small"
                              sx={{
                                backgroundColor: '#fff',
                                fontSize: '12px',
                                maxWidth: '100%',
                                width: 'fit-content',
                                '& .MuiChip-label': {
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                  maxWidth: '200px',
                                },
                              }}
                            />
                          ))}
                        </Box>
                      )}
                    </Box>
                    <IconComponent
                      sx={{
                        width: 80,
                        height: 80,
                        color: '#575757',
                        flexShrink: 0,
                      }}
                    />
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </Box>
      {/* 저장 버튼 */}
      <Box sx={{ px: 2, pb: 2, pt: 2 }}>
        <Button
          name="저장"
          fullWidth
          onClick={props.SaveLogic1}
          sx={{
            fontSize: '16px',
            fontWeight: 'bold',
            py: 1.5,
          }}
        />
      </Box>
      {/* 리스트 선택 다이얼로그 */}
      {props.listDialogOpen && (
        <Dialog
          title={props.listTitle}
          open={props.listDialogOpen}
          onClose={() => props.setListDialogOpen(false)}
          titleSx={{ fontSize: '18px', fontWeight: 'bold', pt: 3 }}
          contentSx={{
            display: 'flex',
            flexDirection: 'column',
            p: 3,
            px: 3,
            overflow: 'hidden',
          }}
          actionsSx={{ p: 0 }}
          PaperProps={{
            sx: {
              m: 2,
              borderRadius: 4,
              width: 'calc(100% - 32px)',
              maxWidth: '100%',
              maxHeight: `calc(100vh - ${statusBar + navBar + 32}px)`,
              display: 'flex',
              flexDirection: 'column',
            },
          }}
          scroll="paper"
          fullWidth={true}
          useSaveButton={false}
          useSaveAfterClose={false}
          useCloseButton={false}
          onSave={() => {}}
          maxWidth={false}
          content={
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: 0,
                flex: 1,
              }}
            >
              {(props.selectedType === 'education' ||
                props.selectedType === 'workplan') && (
                <Typography sx={{ color: '#666', fontSize: '14px', mb: 1 }}>
                  최대 {props.maxMultiSelect}개까지 선택할 수 있습니다. (
                  {props.selectedType === 'education'
                    ? props.selectedEducations?.length || 0
                    : props.selectedWorkplans?.length || 0}
                  /{props.maxMultiSelect})
                </Typography>
              )}
              <Box
                sx={{
                  width: '100%',
                  flex: 1,
                  minHeight: 0,
                  overflow: 'auto',
                  mb: 2,
                }}
              >
                {listData.length === 0 ? (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      p: 3,
                      minHeight: '200px',
                    }}
                  >
                    <Typography sx={{ color: '#888' }}>
                      조회된 데이터가 없습니다.
                    </Typography>
                  </Box>
                ) : (
                  <List disablePadding>
                    {listData.map((item, index) => {
                      let displayText = '';
                      if (props.selectedType === 'video') {
                        displayText =
                          item.videoFileName || `동영상 ${index + 1}`;
                      } else if (props.selectedType === 'education') {
                        displayText = item.eduFileName || `파일 ${index + 1}`;
                      } else if (props.selectedType === 'workplan') {
                        displayText =
                          item.fileName || `작업계획서 ${index + 1}`;
                      }

                      let isSelected = false;
                      let selectionOrder = null;

                      if (props.selectedType === 'video') {
                        isSelected =
                          props.selectedVideo &&
                          props.selectedVideo.videoFileName ===
                            item.videoFileName;
                      } else if (props.selectedType === 'education') {
                        isSelected = IsEducationSelected(item);
                        selectionOrder = GetEducationSelectionOrder(item);
                      } else if (props.selectedType === 'workplan') {
                        isSelected = IsWorkplanSelected(item);
                        selectionOrder = GetWorkplanSelectionOrder(item);
                      }

                      return (
                        <Fragment key={index}>
                          <ListItem disablePadding>
                            <ListItemButton
                              onClick={() => HandleItemClick(item)}
                              sx={{
                                backgroundColor: isSelected
                                  ? 'rgba(25, 118, 210, 0.08)'
                                  : 'transparent',
                                '&:hover': {
                                  backgroundColor: 'rgba(25, 118, 210, 0.15)',
                                },
                                borderLeft: isSelected
                                  ? '4px solid #1976d2'
                                  : '4px solid transparent',
                              }}
                            >
                              {selectionOrder && (
                                <Box
                                  sx={{
                                    width: 24,
                                    height: 24,
                                    borderRadius: '50%',
                                    bgcolor: '#1976d2',
                                    color: '#fff',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '12px',
                                    fontWeight: 'bold',
                                    mr: 1.5,
                                    flexShrink: 0,
                                  }}
                                >
                                  {selectionOrder}
                                </Box>
                              )}
                              <ListItemText
                                primary={displayText}
                                sx={{
                                  '& .MuiListItemText-primary': {
                                    fontSize: '16px',
                                    fontWeight: isSelected ? 'bold' : 'normal',
                                    color: isSelected ? '#1976d2' : 'inherit',
                                  },
                                }}
                              />

                              {(props.selectedType === 'education' ||
                                props.selectedType === 'workplan') && (
                                <IconButton
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    OpenDocumentPreview(
                                      item,
                                      props.selectedType
                                    );
                                  }}
                                  sx={{ ml: 0.5 }}
                                >
                                  <VisibilityIcon fontSize="small" />
                                </IconButton>
                              )}
                              {isSelected && !selectionOrder && (
                                <CheckCircleIcon
                                  sx={{
                                    color: '#1976d2',
                                    fontSize: '20px',
                                    ml: 1,
                                  }}
                                />
                              )}
                            </ListItemButton>
                          </ListItem>

                          {index < listData.length - 1 && <Divider />}
                        </Fragment>
                      );
                    })}
                  </List>
                )}
              </Box>

              <Button
                sx={{
                  width: '100%',
                  height: '36px',
                  borderRadius: '18px',
                  flexShrink: 0,
                }}
                name={'닫기'}
                onClick={() => props.setListDialogOpen(false)}
              />
            </Box>
          }
        />
      )}
      {/* 동영상 미리보기 (VideoPreview 컴포넌트 사용) */}
      {videoPreviewData && (
        <VideoPreview
          open={videoPreviewOpen}
          onClose={() => {
            setVideoPreviewOpen(false);
            if (props.setListDialogOpen) {
              props.setListDialogOpen(true);
            }
            setTimeout(() => {
              setVideoPreviewData(null);
              setSelectedItemForPreview(null);
            }, 300);
          }}
          videoData={videoPreviewData}
          onConfirm={() => {
            if (selectedItemForPreview) {
              props.HandleConfirmPreview(selectedItemForPreview);
            }
            setVideoPreviewOpen(false);
            if (props.setListDialogOpen) {
              props.setListDialogOpen(false);
            }
            setTimeout(() => {
              setVideoPreviewData(null);
              setSelectedItemForPreview(null);
            }, 300);
          }}
        />
      )}
      {/* 문서 미리보기 (교육 파일, 작업계획서) */}
      {documentPreviewData && (
        <DocumentPreview
          open={documentPreviewOpen}
          onClose={() => {
            setDocumentPreviewOpen(false);
            if (props.setListDialogOpen) {
              props.setListDialogOpen(true);
            }
            setTimeout(() => {
              setDocumentPreviewData(null);
              setSelectedItemForPreview(null);
            }, 300);
          }}
          documentData={documentPreviewData}
          onConfirm={() => {
            setDocumentPreviewOpen(false);
            if (props.setListDialogOpen) {
              props.setListDialogOpen(true);
            }
            setTimeout(() => {
              setDocumentPreviewData(null);
              setSelectedItemForPreview(null);
            }, 300);
          }}
        />
      )}
    </>
  );
}

export default M_TBS_CUSTOM;
